import styled from '@emotion/styled'

export default styled.h4`
  font-family: monospace;
  padding-left: 1em;
`